import { USER_AUTH_ENDPOINT } from 'common/constants/endpoints'
import { request } from 'common/utils'

import query from '../graphql/getUserRights.graphql'
import { GetUserrightsQuery } from '../interfaces/schemaDefinition'

export const fetchUserRights: () => Promise<GetUserrightsQuery['rights']> = async () => {
  const response = await request<GetUserrightsQuery>(USER_AUTH_ENDPOINT, query)
  return response.rights
}
